import React from 'react'
import { searchSites } from '../../services/sites';
import CustomAsyncSelect from './CustomAsyncSelect';

const SiteSelect = ({name, control, rules}) => {
    // Fetch function specifically for sites 
    const loadSites = async (inputValue) => {
        if (inputValue.length < 3) {
            return [];
        }

        try {
            const response = await searchSites(inputValue);
            // Return array of sites from Laravel API 
            return response.data.map((site) => ({label: site.name, value: site.id}));
        } catch {
            return [];
        }
    }
  return (
    <CustomAsyncSelect
        name={name}
        rules={rules}
        placeholder='Search for a site....'
        loadOptions={loadSites}
        control={control}
    />
  )
}

export default SiteSelect